module.exports = __webpack_public_path__ + "img/lbx.31e7013b.png";